import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=1d0829c5&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0829c5')) {
      api.createRecord('1d0829c5', component.options)
    } else {
      api.reload('1d0829c5', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=1d0829c5&", function () {
      api.rerender('1d0829c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/layout/sidebars/Contacts.vue"
export default component.exports